import { tessaCitrusApi } from "./axiosConfig";

export const login = async (credentials) => {
    const { data } = await tessaCitrusApi.post("auth/login", credentials);
    return data;
};

export const getSession = async () => {
    const { data } = await tessaCitrusApi.get("auth/me", {
        params: { _t: Date.now() },
    });
    return data;
};

export const logout = async () => {
    const { data } = await tessaCitrusApi.post("auth/logout", null, {
        params: { _t: Date.now() },
    });
    return data;
};

export const getUsuariosAdmin = async (params) => {
    const { data } = await tessaCitrusApi.get("usuarios", { params });
    return data;
}

export const patchMiPassword = async (passwords) => {
    const { data } = await tessaCitrusApi.patch("usuarios/me/password", passwords);
    return data;
}

export const patchUsuarioPassword = async (idUsuario, password) => {
    const { data } = await tessaCitrusApi.patch(`usuarios/${idUsuario}/password`, password);
    return data;
}

export const patchUsuario = async (idUsuario, usuario) => {
    const { data } = await tessaCitrusApi.patch(`usuarios/${idUsuario}`, usuario);
    return data;
}

export const postUsuario = async (data) => {
    const { data: responseData } = await tessaCitrusApi.post("usuarios", data);
    return responseData;
}

export const getRolesYDepartamentos = async (params) => {
    const { data } = await tessaCitrusApi.get("roles", { params });
    return data;
}

export const postRol = async (rol) => {
    const { data } = await tessaCitrusApi.post("roles", rol);
    return data;
}

export const getRol = async (idRol) => {
    const { data } = await tessaCitrusApi.get(`roles/${idRol}`);
    return data;
}

export const patchRol = async (idRol, rol) => {
    const { data } = await tessaCitrusApi.patch(`roles/${idRol}`, rol);
    return data;
}

export const deleteRol = async (idRol) => {
    const { data } = await tessaCitrusApi.delete(`roles/${idRol}`);
    return data;
}


// Almacenes
export const getAlmacenes = async (params) => {
    const { data } = await tessaCitrusApi.get("almacenes", { params });
    return data;
}

export const postAlmacen = async (almacen) => {
    const { data } = await tessaCitrusApi.post("almacenes", almacen);
    return data;
}

export const getAlmacen = async (codAlmacen) => {
    const { data } = await tessaCitrusApi.get(`almacenes/${codAlmacen}`);
    return data;
}

export const patchAlmacen = async (codAlmacen, almacen) => {
    const { data } = await tessaCitrusApi.patch(`almacenes/${codAlmacen}`, almacen);
    return data;
}

export const deleteAlmacen = async (codAlmacen) => {
    const { data } = await tessaCitrusApi.delete(`almacenes/${codAlmacen}`);
    return data;
}

// Confecciones
export const getConfecciones = async (params) => {
    const { data } = await tessaCitrusApi.get("confecciones", { params });
    return data;
}

export const getGruposConfeccion = async (params) => {
    const { data } = await tessaCitrusApi.get("grupos-confeccion", { params });
    return data;
}

export const getGruposVariedad = async (params) => {
    const { data } = await tessaCitrusApi.get("grupos-variedad", { params });
    return data;
}

// Maquinas
export const getTiposMaquinas = async (params) => {
    const { data } = await tessaCitrusApi.get("tipos-maquinas", { params });
    return data;
}

export const postTipoMaquina = async (tipoMaquina) => {
    const { data } = await tessaCitrusApi.post("tipos-maquinas", tipoMaquina);
    return data;
}

export const getTipoMaquina = async (codTipoMaquina) => {
    const { data } = await tessaCitrusApi.get(`tipos-maquinas/${codTipoMaquina}`);
    return data;
}

export const patchTipoMaquina = async (codTipoMaquina, tipoMaquina) => {
    const { data } = await tessaCitrusApi.patch(`tipos-maquinas/${codTipoMaquina}`, tipoMaquina);
    return data;
}

export const deleteTipoMaquina = async (codTipoMaquina) => {
    const { data } = await tessaCitrusApi.delete(`tipos-maquinas/${codTipoMaquina}`);
    return data;
}

// Colores personales de maquinas
export const getMisColoresMaquinas = async (params) => {
    const { data } = await tessaCitrusApi.get("usuarios/me/colores-maquinas", { params });
    return data;
}

export const patchMiColorMaquina = async (codMaquina, colorMaquina) => {
    const { data } = await tessaCitrusApi.patch(`usuarios/me/colores-maquinas/${codMaquina}`, { colorMaquina });
    return data;
}

export const deleteMiColorMaquina = async (codMaquina) => {
    const { data } = await tessaCitrusApi.delete(`usuarios/me/colores-maquinas/${codMaquina}`);
    return data;
}

// Salidas produccion
export const getSalidasProduccion = async (params) => {
    const { data } = await tessaCitrusApi.get("salidas-produccion", { params });
    return data;
}

export const postSalidaProduccion = async (salidaProduccion) => {
    const { data } = await tessaCitrusApi.post("salidas-produccion", salidaProduccion);
    return data;
}

export const patchSalidaProduccion = async (codMaquina, salidaProduccion) => {
    const { data } = await tessaCitrusApi.patch(`salidas-produccion/${codMaquina}`, salidaProduccion);
    return data;
}

export const deleteSalidaProduccion = async (codMaquina) => {
    const { data } = await tessaCitrusApi.delete(`salidas-produccion/${codMaquina}`);
    return data;
}

// Parametros tiempo
const getParametroTiempoPath = (codMaquina, codGrupoConfeccion, codGrupoVariedad, peso) => (
    `parametros-tiempo/${encodeURIComponent(codMaquina)}/${encodeURIComponent(codGrupoConfeccion)}/${encodeURIComponent(codGrupoVariedad)}/${encodeURIComponent(peso)}`
)

export const getParametrosTiempo = async (params) => {
    const { data } = await tessaCitrusApi.get("parametros-tiempo", { params });
    return data;
}

// Pedidos
export const getPedidosLineasPendientes = async (params) => {
    const { data } = await tessaCitrusApi.get("pedidos/lineas/pendientes", { params });
    return data;
}

export const getPlanificaciones = async (params) => {
    const { data } = await tessaCitrusApi.get("planificaciones", { params });
    return data;
}

export const getPlanificacionesTablero = async (params) => {
    const { data } = await tessaCitrusApi.get("planificaciones/tablero", { params });
    return data;
}

export const postPlanificacion = async (planificacion) => {
    const { data } = await tessaCitrusApi.post("planificaciones", planificacion);
    return data;
}

export const patchPlanificacion = async (idPlanificacion, planificacion) => {
    const { data } = await tessaCitrusApi.patch(`planificaciones/${idPlanificacion}`, planificacion);
    return data;
}

export const deletePlanificacion = async (idPlanificacion) => {
    const { data } = await tessaCitrusApi.delete(`planificaciones/${idPlanificacion}`);
    return data;
}

export const postParametroTiempo = async (parametroTiempo) => {
    const { data } = await tessaCitrusApi.post("parametros-tiempo", parametroTiempo);
    return data;
}

export const getParametroTiempo = async (codMaquina, codGrupoConfeccion, codGrupoVariedad, peso) => {
    const { data } = await tessaCitrusApi.get(getParametroTiempoPath(codMaquina, codGrupoConfeccion, codGrupoVariedad, peso));
    return data;
}

export const patchParametroTiempo = async (codMaquina, codGrupoConfeccion, codGrupoVariedad, peso, parametroTiempo) => {
    const { data } = await tessaCitrusApi.patch(getParametroTiempoPath(codMaquina, codGrupoConfeccion, codGrupoVariedad, peso), parametroTiempo);
    return data;
}

export const deleteParametroTiempo = async (codMaquina, codGrupoConfeccion, codGrupoVariedad, peso) => {
    const { data } = await tessaCitrusApi.delete(getParametroTiempoPath(codMaquina, codGrupoConfeccion, codGrupoVariedad, peso));
    return data;
}
